module.exports = __webpack_public_path__ + "img/xcxcj.07b7085d.png";